import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var CommaIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    d: "M23.9986 24.81C30.0082 24.81 34.8798 19.9383 34.8798 13.9288C34.8798 7.91929 30.0082 3.04761 23.9986 3.04761C17.9891 3.04761 13.1174 7.91929 13.1174 13.9288C13.1174 19.9383 17.9891 24.81 23.9986 24.81Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9986 4.09522C18.5677 4.09522 14.165 8.49787 14.165 13.9288C14.165 19.3598 18.5677 23.7624 23.9986 23.7624C29.4296 23.7624 33.8322 19.3598 33.8322 13.9288C33.8322 8.49787 29.4296 4.09522 23.9986 4.09522ZM12.0698 13.9288C12.0698 7.34071 17.4105 2 23.9986 2C30.5867 2 35.9275 7.34071 35.9275 13.9288C35.9275 20.5169 30.5867 25.8576 23.9986 25.8576C17.4105 25.8576 12.0698 20.5169 12.0698 13.9288Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8798 12.8812C35.4584 12.8812 35.9275 13.3502 35.9275 13.9288C35.9275 28.6593 26.5726 41.1961 13.4883 45.9371C12.9443 46.1342 12.3436 45.853 12.1465 45.309C11.9494 44.765 12.2306 44.1643 12.7745 43.9672C25.0564 39.517 33.8322 27.7493 33.8322 13.9288C33.8322 13.3502 34.3013 12.8812 34.8798 12.8812Z"
  }));
});
CommaIcon.displayName = 'CommaIcon';
CommaIcon.defaultProps = {
  'aria-label': 'Comma'
};
export default CommaIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/CommaIcon/index.js
// module id = 1817
// module chunks = 12